import { useMsal } from "@azure/msal-react";
import { Button, Col, notification, Row, Typography } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useHistory, useParams } from "react-router-dom";
import { ROUTE_TICKETS } from "../../core/route/ui.routes";
import {
  fetchMyPermissions,
  fetchSelf,
  setToken,
} from "../../core/store/reducers/auth.slice";
import { PERMISSIONS } from "../../shared/constants";
import CognitoPage from "./cognito-login";
import "./index.less";
// import { ROUTE_PATIENTS_LIST } from "../../core/route/ui.routes";

const { Title } = Typography;

function LoginPage() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { instance, accounts } = useMsal();
  const RouteParams: any = useParams();
  const [loginType, setLoginType] = useState("" as any);
  localStorage.setItem(
    "application_id",
    "049cc6ea-b6b0-4555-b9e1-0df257e54d87"
  );
  localStorage.setItem("account_id", "32e03f1e-49e9-4bcd-bdb0-3ec1d73f5bc0");

  useEffect(() => {
    // Check if there's an authenticated account
    if (accounts.length > 0) {
      // Get access token silently
      instance
        .acquireTokenSilent({
          scopes: ["openid", "profile", "email"], // Specify scopes as needed
          account: accounts[0], // Use the first account for simplicity
        })
        .then((response) => {
          // Handle the token response
          initAdLogin(response);
        })
        .catch((error) => {
          console.error("Failed to acquire token:", error);
        });
    }
  }, [instance, accounts]);

  const screenType = {
    desktop: useMediaQuery({ minWidth: 992 }),
    tablet: useMediaQuery({ minWidth: 768, maxWidth: 991 }),
    mobile: useMediaQuery({ maxWidth: 767 }),
  };
  const login = () => {
    // localStorage.setItem("app", RouteParams["app"]);
    // history.push(ROUTE_PATIENTS_LIST)
    instance
      .loginPopup()
      .then(async (response: any) => {
        initAdLogin(response);
        // const response = await dispatch(fetchProfile("users"));
      })
      .catch((error) => {
        // Handle any errors that occur during the login process
        // console.error(error);
        notification.error({
          message: "Some Error Occured While Login",
          description: "Please Close All Browser Windows and Retry Login",
        });
      });
  };
  const loginRedirect = () => {
    instance
      .loginRedirect()
      .then((response) => {
        // Handle the login response
        // initAdLogin(response);
        // console.log(response);
      })
      .catch((error) => {
        // Handle any errors that occur during the login process
        // console.error(error);
        notification.error({
          message: "Some Error Occured While Login",
          description: "Please Close All Browser Windows and Retry Login",
        });
      });
  };
  const initAdLogin = async (response: any) => {
    localStorage.setItem("auth-type", "ad");
    await dispatch(setToken(response.idToken));
    // let data = { name: "hemant" } as any;
    // await dispatch(setUser(data));
    await dispatch(fetchSelf());
    const permissionRes = await dispatch(fetchMyPermissions());
    if (permissionRes?.payload?.data?.data?.scope_values?.actions) {
      let allPermissions =
        permissionRes?.payload?.data?.data?.scope_values?.actions;
      if (
        allPermissions?.indexOf(PERMISSIONS.READ_TICKET) !== -1 ||
        allPermissions?.indexOf(PERMISSIONS.READ_TICKET?.split(".")[0]) !== -1
      ) {
        history.push(ROUTE_TICKETS);
      }
    }
  };

  return (
    <>
      {accounts?.length == 0 && <Row
        align={"middle"}
        className={
          screenType.desktop
            ? "auth-layout full-height"
            : "full-height auth-layout"
        }
      >
        <Col span={14} xl={14} sm={0} xs={0}>
          <div
            className="main-image-wrapper"
            style={{
              backgroundImage: `url(${
                require("../../assets/images/loginImage.svg").default
              })`,
              height: "100vh",
              backgroundColor: "#C1DAE8",
            }}
          />
        </Col>

        <Col xl={10} xs={24} sm={24}>
          <Row>
            <Col
              span={18}
              xs={24}
              offset={screenType.desktop ? 3 : 0}
              style={
                screenType.desktop ? { maxWidth: "400px" } : { padding: "30px" }
              }
            >
              {
                <>
                  <img
                    src="https://d27zjjrd786p5a.cloudfront.net/medi-ui/logo/cipla.png"
                    style={{ maxWidth: "90%" }}
                    height={screenType.desktop ? "70" : "50"}
                  ></img>
                  <Title
                    className={screenType.desktop ? "bold" : "bold"}
                    level={3}
                    style={{ marginBottom: "0px" }}
                  >
                    Log In to Incentive Portal
                  </Title>
                  {loginType == "" && (
                    <>
                      <Button
                        onClick={loginRedirect}
                        block
                        className="login-button mt-3 mb-2"
                        type="primary"
                        size="large"
                      >
                        Login with Microsoft
                      </Button>
                      <Button
                        onClick={() => setLoginType("cognito")}
                        block
                        className="login-button mt-3 mb-5"
                        type="default"
                        size="large"
                      >
                        Login with Cognito
                      </Button>
                    </>
                  )}
                  {loginType == "cognito" && (
                    <>
                      <CognitoPage />
                    </>
                  )}
                </>
              }
              <Col span={0} xs={24} xl={0} xxl={0} sm={0}></Col>
            </Col>
          </Row>
        </Col>
      </Row>}
    </>
  );
}

export default LoginPage;
